import {Injector, Pipe, PipeTransform} from "@angular/core";
import {ConverterService} from "../../../services/converter.service";

export class BaseConverterClass {
  protected converterService: ConverterService;

  constructor(protected injector: Injector) {
    this.converterService = injector.get(ConverterService);
  }
}

@Pipe({
    name: 'localizeSpeed',
    standalone: false
})
export class LocalizeSpeedPipe extends BaseConverterClass implements PipeTransform {
  constructor(protected injector: Injector) {
    super(injector);
  }

  transform(value: number): any {
    return this.converterService.GetSpeedValue(value);
  }
}

@Pipe({
    name: 'localizeUnits',
    standalone: false
})
export class LocalizeUnitsPipe extends BaseConverterClass implements PipeTransform {
  constructor(protected injector: Injector) {
    super(injector);
  }

  transform(value: string): any {
    return this.converterService.Units(value);
  }
}

@Pipe({
    name: 'localizeMeters',
    standalone: false
})
export class LocalizeMetersPipe extends BaseConverterClass implements PipeTransform {
  constructor(protected injector: Injector) {
    super(injector);
  }

  transform(value: number): any {
    return this.converterService.GetMetersValue(value);
  }
}

@Pipe({
    name: 'localizeKMeters',
    standalone: false
})
export class LocalizeKMetersPipe extends BaseConverterClass implements PipeTransform {
  constructor(protected injector: Injector) {
    super(injector);
  }

  transform(value: number): any {
    return this.converterService.GetKMetersValue(value);
  }
}

@Pipe({
    name: 'localizeHours',
    standalone: false
})
export class LocalizeHoursPipe extends BaseConverterClass implements PipeTransform {
  constructor(protected injector: Injector) {
    super(injector);
  }

  transform(value: number): any {
    return Math.round(value / 3600000);
  }
}

@Pipe({
    name: 'localizeSeconds',
    standalone: false
})
export class LocalizeSecondsPipe extends BaseConverterClass implements PipeTransform {
  constructor(protected injector: Injector) {
    super(injector);
  }

  transform(value: number): any {
    return Math.round(value / 1000);
  }
}


@Pipe({
    name: 'localizeDays',
    standalone: false
})
export class LocalizeDaysPipe extends BaseConverterClass implements PipeTransform {
  constructor(protected injector: Injector) {
    super(injector);
  }

  transform(value: number): any {
    return Math.round(value / (24 * 3600000));
  }
}

@Pipe({
    name: 'datetime',
    standalone: false
})
export class DateTimePipe extends BaseConverterClass implements PipeTransform {
  constructor(protected injector: Injector) {
    super(injector);
  }

  transform(value: number, format: string): string
  {
    if (!value)
      return "";

    if (!format)
      format = '%0D.%0M.%0Y %0h:%0m';

    const dt = new Date();
    dt.setTime(value);

    let str = format;
    str = str.replace("%D", dt.getDate().toString());
    str = str.replace("%0D", ((dt.getDate() < 10) ? "0" : "") + dt.getDate());
    str = str.replace("%M", (dt.getMonth() + 1).toString());
    str = str.replace("%0M", ((dt.getMonth() < 9) ? "0" : "") + (dt.getMonth() + 1));
    str = str.replace("%Y", (dt.getFullYear() - 2000).toString());
    str = str.replace("%0Y", dt.getFullYear().toString());

    str = str.replace("%h", dt.getHours().toString());
    str = str.replace("%0h", ((dt.getHours() < 10) ? "0" : "") + dt.getHours());
    str = str.replace("%m", dt.getMinutes().toString());
    str = str.replace("%0m", ((dt.getMinutes() < 10) ? "0" : "") + dt.getMinutes());
    str = str.replace("%s", dt.getSeconds().toString());
    str = str.replace("%0s", ((dt.getSeconds() < 10) ? "0" : "") + dt.getSeconds());

    return str;
  }
}
@Pipe({
    name: 'time',
    standalone: false
})
export class TimePipe extends BaseConverterClass implements PipeTransform {
  constructor(protected injector: Injector) {
    super(injector);
  }

  transform(value: number): string {

    value = value / 1000;

    let sec = value % 60;
    value = (value - sec) / 60;

    let min = value % 60;
    value = (value - min) / 60;

    return value + ":" +
      ((min < 10) ? "0" : "") + min + ":" +
      ((sec < 10) ? "0" : "") + sec;
  }
}
